import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TextAction from '../TextAction';

import './styles.css';

const propTypes = {
  message: PropTypes.string.isRequired,
  box: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
  actionText: PropTypes.string,
  onRetry: PropTypes.func,
  className: PropTypes.string,
};

const defaultProps = {
  box: false,
  error: false,
  success: false,
  actionText: '',
  onRetry: null,
  className: '',
};

class AlertMessage extends Component {
  render() {
    const {
      message,
      box,
      actionText,
      onRetry,
      className,
      error,
      success,
    } = this.props;

    return (
      <div
        className={
          `AlertMessage${' '}
          ${box ? 'AlertMessage--box ' : ''}
          ${error ? 'AlertMessage--error ' : ''}
          ${box && error ? 'AlertMessage--box-error ' : ''}
          ${box && success ? 'AlertMessage--box-success ' : ''}
          ${success ? 'AlertMessage--success ' : ''}
          ${className || ''}`
        }
      >
        <p className="AlertMessage__message">{message}</p>
        {
          actionText && onRetry &&
          (
            <TextAction
              className="AlertMessage__action"
              onClick={onRetry}
            >
              {actionText}
            </TextAction>
          )
        }
      </div>
    );
  }
}

AlertMessage.propTypes = propTypes;
AlertMessage.defaultProps = defaultProps;

export default AlertMessage;
